import { render, staticRenderFns } from "./modification.vue?vue&type=template&id=6ca31fc5&"
import script from "./modification.vue?vue&type=script&lang=js&"
export * from "./modification.vue?vue&type=script&lang=js&"
import style0 from "./modification.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports